import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  fetchAllVendorsManagement,
  setVendor,
  fetchManagementFilters,
  fetchAllVendorsTobeMerged,
} from 'actions/vendors';
import {
  Container,
  HeaderFlexRow,
  HeadingTitle,
  PlainButton,
} from 'components/styled-components';
import Controls from 'components/vendors/controls';
import Pagination from 'components/pagination';
import VendorTable from 'components/vendors/table';
import hasPermission from 'utils/hasPermission';
import permissions from 'utils/permissions';
import MergeVendorsDrawer from './MergeVendorsDrawer';
import { fetchAllVendorStatus } from 'actions/utils';
import constants from 'utils/constants';

class ManageVendors extends Component {
  state = {
    isOpen: false,
    newVendor: false,
    currentPage: 0,
    perPage: 10,
    selectedFilter: null,
    filterField: '',
    displayFilter: '',
    query: '',
    orderby: 'vendorID',
    orderDesc: false,
  };

  componentDidMount() {
    const { currentPage, perPage } = this.state;
    this.updateVendorsList(currentPage, perPage, undefined, 0, true);
    this.props.fetchAllVendorStatus();
    this.props.fetchManagementFilters({
      limit: -1,
      start: 0,
    });
  }

  updateVendorsList = (currentPage, perPage, params = undefined) => {
    this.props.fetchAllVendorsManagement({
      limit: perPage,
      start: currentPage * perPage,
      ...params,
    });
  };

  updateMergeVendorsList = () => {
    this.props.fetchAllVendorsTobeMerged({ limit: -1, start: 0 });
  };

  handleEditClick = vendor => {
    if (vendor === 'new') {
      this.props.history.push(`manage-parties/new`);
    } else {
      // set the vendor in the redux store and navigate to their details page
      this.props.setVendor(vendor);
      this.props.history.push(`manage-parties/${vendor.vendorID}`);
    }
  };

  handleAddVendorClick = () => {
    this.setState({ isOpen: true, newVendor: true });
  };

  handlePageClick = currentPage => {
    this.setState({ currentPage }, () =>
      this.updateVendorsList(currentPage, this.state.perPage)
    );
  };

  handlePerPageChange = perPage => {
    this.setState({ perPage: perPage.value }, () =>
      this.updateVendorsList(0, perPage.value)
    );
  };

  buildParams = () => {
    const {
      selectedFilter,
      filterField,
      query,
      orderby,
      orderDesc,
    } = this.state;

    return {
      ...(selectedFilter && { [filterField]: selectedFilter.value }),
      ...(query !== '' && { searchQuery: query }),
      ...(orderDesc ? { orderby, orderDir: 'desc' } : { orderby }),
    };
  };

  handleSearch = query => {
    this.setState({ query, currentPage: 0 }, () => {
      const params = this.buildParams();
      this.updateVendorsList(
        0,
        this.state.perPage,
        params,
        constants.SEARCH_TYPING_DELAY_MILLISECONDS
      );
    });
  };

  handleChangeFilter = (selectedFilter, filterField, displayFilter) => {
    this.setState(
      { filterField, displayFilter, selectedFilter, currentPage: 0 },
      () => {
        const params = this.buildParams();

        this.props.fetchAllVendorsManagement({
          start: 0,
          limit: this.state.perPage,
          ...params,
        });
      }
    );
  };

  clearFilters = () => {
    this.setState(
      { filterField: '', displayFilter: '', selectedFilter: null },
      () => {
        const params = this.buildParams();
        this.props.fetchAllVendorsManagement({
          start: 0,
          limit: this.state.perPage,
          ...params,
        });
      }
    );
  };

  handleOrderByClick = orderby => {
    if (orderby === this.state.orderby && !this.state.orderDesc) {
      this.setState({ orderDesc: true }, () => {
        const params = this.buildParams();
        this.props.fetchAllVendorsManagement({
          start: 0,
          limit: this.state.perPage,
          ...params,
        });
      });
    } else if (orderby === this.state.orderby && this.state.orderDesc) {
      this.setState({ orderDesc: false }, () => {
        const params = this.buildParams();
        this.props.fetchAllVendorsManagement({
          start: 0,
          limit: this.state.perPage,
          ...params,
        });
      });
    } else {
      this.setState({ orderby, orderDesc: false }, () => {
        const params = this.buildParams();
        this.props.fetchAllVendorsManagement({
          start: 0,
          limit: this.state.perPage,
          ...params,
        });
      });
    }
  };

  render() {
    const { vendors, allVendorsToMerge, isFetching, appUser } = this.props;
    const { query } = this.state;
    return (
      <Container>
        <HeaderFlexRow>
          <HeadingTitle>Third Party Management</HeadingTitle>
          <span>
            {hasPermission(
              appUser.permissions,
              permissions.MODIFY_THIRD_PARTY
            ) && (
              <MergeVendorsDrawer
                handleDialog={this.handleMergeDialog}
                allVendorsToMerge={allVendorsToMerge}
                updateVendorsList={() => this.updateMergeVendorsList()}
                {...this.props}
              />
            )}
            {hasPermission(appUser.permissions, [
              permissions.CREATE_THIRD_PARTY,
              permissions.CREATE_USERS,
            ]) && (
              <PlainButton onClick={() => this.handleEditClick('new')}>
                Add Third Party
              </PlainButton>
            )}
          </span>
        </HeaderFlexRow>
        <Controls
          handleSearch={this.handleSearch}
          handleChangeFilter={this.handleChangeFilter}
          filters={this.props.filters}
          loaded={this.props.filtersLoaded}
          selectedFilter={this.state.selectedFilter}
          displayFilter={this.state.displayFilter}
          clearFilters={this.clearFilters}
          vendorStatus={this.props.vendorStatus}
        />
        <VendorTable
          vendors={vendors.result}
          handleEditClick={this.handleEditClick}
          handleOrderByClick={this.handleOrderByClick}
          orderby={this.state.orderby}
          orderDesc={this.state.orderDesc}
          isFetching={isFetching}
          query={query}
        />
        <Pagination
          numRecords={vendors.totalCount}
          perPage={this.state.perPage}
          currentPage={this.state.currentPage}
          onPageClick={this.handlePageClick}
          handlePerPageChange={this.handlePerPageChange}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  vendors: state.vendors.management,
  isFetching: state.vendors.isFetchingManagement,
  errorMessage: state.vendors.errorMessageManagement,
  filters: state.vendors.filters,
  filtersLoaded: state.vendors.filtersLoaded,
  vendorStatus: state.utils.vendorStatus,
  allVendorsToMerge: state.vendors.vendorsToMerge,
});

ManageVendors = withRouter(
  connect(
    mapStateToProps,
    {
      fetchAllVendorsManagement,
      setVendor,
      fetchManagementFilters,
      fetchAllVendorStatus,
      fetchAllVendorsTobeMerged,
    }
  )(ManageVendors)
);

export default ManageVendors;
